<template lang="pug">
.input-wrapper
  label(v-show="label" :for="label") {{ label }}
  input(
    :id="label"
    type="file"
    accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"
    v-bind="$attrs"
    :value="value"
    v-on="{...$listeners, input: (e) => $emit('input', e.target.value)}")
</template>

<script>
export default {
  name: 'RomatchFilePicker',
  inheritAttrs: false,
  props: {
    label: String,
    value: [String, Number],
  },
}
</script>

<style scoped lang="stylus">
@import '../../assets/_forms.styl'

.input-wrapper
  input-wrapper()
</style>
